import { useNavigate } from 'react-router-dom'
import {
  DirectoryItemContainer,
  BackgroundImage,
  Body,
} from './directoryItem.styles'

const DirectoryItem = ({ category }) => {
  const { title, imageUrl, route } = category
  const navigate = useNavigate()

  const navigateHandler = () => navigate(route)

  return (
    <DirectoryItemContainer onClick={navigateHandler}>
      <BackgroundImage imageUrl={imageUrl} />
      <Body className='body'>
        <h2>{title}</h2>
        <p>Shop Now</p>
      </Body>
    </DirectoryItemContainer>
  )
}

export default DirectoryItem
